import { Helmet } from "react-helmet";

export default function GoogleAnalytics() {
    return (
        <Helmet>
            <script
                async
                src="https://www.googletagmanager.com/gtag/js?id=G-T81EPHSRPZ"
            />
            <script>
                {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-T81EPHSRPZ', {
            send_page_view: true
          });
        `}
            </script>
        </Helmet>
    );
}
